export default "__VITE_ASSET__DiewImTO__"